<template>
  <img class="banner-image" src="../assets/toppic/图片-02.jpg"/>
  <div class="panel-div">
    <el-row v-if="companyinfoList && companyinfoList.length > 0">
      <el-col  :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-for="item in companyinfoList" :key="item.title">
        <router-link :underline="false" :to="'/companytechnologydetial/'+item.id" style="text-decoration: none;">
          <div class="archive-info">
            <img :src="item.coverImage" />
            <div class="content-body">
              <p class="p-title">{{truncateStr(item.title,60)}}</p>
              <p class="p-descrption">{{truncateStr(item.summary,200)}}</p >
            </div>
          </div>
        </router-link>

      </el-col>
    </el-row>
    <el-row>
      <el-col  v-if="!companyinfoList || companyinfoList.length == 0">
        <el-empty :description="locale[language.code].companynews.emptyTips"></el-empty>
      </el-col>
    </el-row>

    <!--    <pagination-->
    <!--        v-show="total>0"-->
    <!--        :total="total"-->
    <!--        :page.sync="queryParams.pageNum"-->
    <!--        :limit.sync="queryParams.pageSize"-->
    <!--        @pagination="getList"-->
    <!--    />-->
    <el-pagination
        class="archive-pages"
        background
        @current-change="changePage"
        layout="prev, pager, next"
        :total="total">
    </el-pagination>

  </div>

</template>

<script>
import{ companytechnology } from "@/api/CompanyTechnology";
import { truncateStr } from "@/utils/ruoyi";
import locale from "@/locale/locale";


export default {
  name: 'CompanyTechnology',

  props: {
    msg: String
  },
  data(){
    return {
      locale:locale,
      language:null,
      companyinfoList:[],
      activeName:null,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: null,
        languageId: null,
      },
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");

    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },
  methods: {
    truncateStr(str,length){
      return truncateStr(str,length);
    },
    initData() {
      this.queryParams.languageId = this.language.id;
      companytechnology(this.queryParams).then(res => {
        console.log(res);
        this.companyinfoList = res.rows;
        this.total = res.total;
        if(this.companyinfoList.length > 0){
          this.activeName = this.companyinfoList[0].title;
        }
      });
    },
    changePage(target){
      console.log(target)
      // this.queryParams.pageNum = pageNum;
      // this.initData();
    },
    changePanel(index) {
      this.activeName = this.companyinfoList[index].title;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-div{
  padding:20px 35px;
  margin:20px 20px;
  text-align: left;
}

.archive-info{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin: 10px 10px;
  background: #F6F6F6;
  padding:12px 16px;
  border-radius: 6px;
}

.archive-info img{
  width:100px;
}

.archive-info .content-body{
  margin-left: 10px;
}

.archive-info .content-body .p-title{
  font-weight: 600;
  margin-bottom: 10px;
  color:#101010;
  text-decoration: none;
}
@media (max-width: 720px) {

  .panel-div{
    padding:20px 0px!important;
    margin:20px 5px!important;
  }
}


.archive-info .content-body .p-descrption{
  font-size: 13px;
  text-decoration: none;
  color:#303133;
}

.archive-pages{
  justify-content: center;
  margin:25px 20px;
  text-decoration: none;
}


</style>
